import { teaReport, setTeaConfig } from '$tea';
import cookieConfigManager from './cookie-consent-manager';

export type UserConfig = {
  region: string;
  isFTC: boolean;
  i18n: { [key: string]: string };
  disabled: boolean;
};

export function readUserConfig(userConfigEleId: string, locale: string): UserConfig | null {
  let userConfig: string | undefined | null;
  try {
    userConfig = document.getElementById(userConfigEleId)?.textContent;
    const {
      i18n = {},
      appProps: { region = '', $user: { ftcUser = false } = {} } = {},
      config: { cookieBanner: { cookiesAwaitConsent = {}, disabled = false } = {} } = {},
    } = JSON.parse(userConfig as string);

    cookieConfigManager.setCookieConfig(cookiesAwaitConsent);
    setTeaConfig({
      locale,
      region,
    });
    return {
      region,
      isFTC: ftcUser,
      i18n,
      disabled,
    };
  } catch (e) {
    console.error(e);
    teaReport('cookie_banner_fetch_config_failed', {
      error_message: `readUserConfig fail: ${e}`,
      config_content: userConfig || '',
    });
    return null;
  }
}
